export default __webpack_public_path__ + "static/media/navy-vaccine-lg.ed60ad21.svg";